export const BASE_URL = 'https://api.niko.giac.by' // url для запросов на сервер

export const STATISTICS_URL = '/statistics'
export const FEEDBACK_URL = '/feedback'
export const TEST_URL = '/test'
export const TESTS_URL = '/tests'
export const AUTHORIZATION_URL = '/authorization'
export const PROFILE_URL = '/profile'
export const TASK_CREATOR_URL = '/questionCreator/'
export const TEST_CREATOR_URL = '/test-creator/'
export const TEST_CREATOR_CREATOR_URL = '/test-creator/creator/'
export const FILTER_EDITOR_URL = '/filter-editor'
export const FILE_URL = '/files'
export const BACKUP ='/database/backup'
export const TEXT_CREATOR_URL ='/create-text/'
export const COMPLEX_CREATOR_URL ='/create-complex-task/'
export const MODERATOR_URL ='/moderator'
export const INFORMATION_URL='/information'

